import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=3f5d6186&scoped=true&"
import script from "./TabMenu.vue?vue&type=script&lang=js&"
export * from "./TabMenu.vue?vue&type=script&lang=js&"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=3f5d6186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5d6186",
  null
  
)

export default component.exports